import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { BigBreadcrumbs, WidgetGrid } from '../../../components';
import { requestReferralDetails } from '../../../store/referral-directory/ReferralDirectoryActions';
import { requestReferralContacts } from '../../../store/contact-manager/ContactManagerActions';
import { hostTitle } from '../../../config/ui';

class ReferralDetail extends React.Component {

  componentWillMount() {
    this.props.getReferral(this.props.params.id, {
      tenantID: this.props.tenantId,
    });

    this.props.getReferralContacts(this.props.params.id, {
      tenantID: this.props.tenantId,
    });
  }

  onCancel = () => {
    hashHistory.push(`/referral-directory/`);
  };


  render() {
    const { 
      data: { referral, isLoading },
      contacts
    } = this.props;

    return (
      <div id="content">
        {referral.id && (
          <Helmet title={`${referral.id} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Resource Library',
            { title: 'Referral Manager', route: '/referral-directory' },
            'Detail',
          ]}
          icon="fa fa-fw fa-book"
          className=""
        />

        <WidgetGrid>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="product-content product-wrap clearfix product-deatil">
                {isLoading &&
                  <div className="spinner"></div>
                }
                {referral.id && (
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}>
                        Back
                      </button>
                      <h2 className="name">
                        Referral Details
                      </h2>
                      <hr className="simple" />
                      <br />

                      <div className="row">
                        <div className="col-md-6">
                          <dl>
                            <dt>Provider/Organization</dt>
                            <dd>
                              {referral.organization}
                            </dd>
                            <br />
                            <dt>Type</dt>
                            <dd>
                              {referral.type.name}
                            </dd>
                            <br />
                            <dt>Category</dt>
                            <dd>
                              {referral.specialty ? referral.specialty.name : ''}
                            </dd>
                            <dd>
                              {referral.categories &&
                                referral.categories.map(el => (
                                  <li key={el.id}>
                                    <span>
                                      {el.name}
                                    </span>
                                    <br />
                                  </li>
                                ))}
                            </dd>
                            <br />
                            <dt>Insurance Provider</dt>
                            <dd>
                              {referral.insuranceProvider}
                            </dd>
                            <br />
                            <dt>Website</dt>
                            <dd>
                              <a href={`${(referral.website.includes('https')) ? referral.website : 'https://' + referral.website}`} target='_blank'>{referral.website}</a>
                            </dd>
                            <br />
                            <dt>Description</dt>
                            <dd>
                              {referral.description}
                            </dd>
                            <br />
                            <dt>Record Owner</dt>
                            <dd>
                              {referral.owner ? referral.owner.name : ''}
                            </dd>
                            <br />
                            <dt>Hours</dt>
                            <dd>
                              {referral.hours}
                            </dd>
                            <br />
                            <dt>Street Address</dt>
                            <dd>
                              {referral.streetAddress}
                            </dd>
                            <br />
                            <dt>City</dt>
                            <dd>
                              {referral.city}
                            </dd>
                            <br />
                            <dt>State</dt>
                            <dd>
                              {referral.state.name}
                            </dd>
                            <br />
                            <dt>Zip</dt>
                            <dd>
                              {referral.zipCode}
                            </dd>
                            <br />
                            <dt>Phone</dt>
                            <dd>
                              {referral.phone}
                            </dd>
                            <br />
                            <dt>Fax</dt>
                            <dd>
                              {referral.fax}
                            </dd>
                          </dl>
                        </div>
                        <div className="col-md-6">
                          <dl>
                            <dt>NPI Number</dt>
                            <dd>
                              {referral.npiNumber}
                            </dd>
                            <br />
                            <dt>Eligibilty</dt>
                            <dd>
                              {referral.eligibilty}
                            </dd>
                            <br />
                            <dt>ReferralNeeded</dt>
                            <dd>
                              {referral.referralNeeded ? 'Yes' : 'No'}
                            </dd>
                            <br />
                            <dt>ReferralNeededDescription</dt>
                            <dd>
                              {referral.referralNeededDescription}
                            </dd>
                            <br />
                            <dt>HowToAccessService</dt>
                            <dd>
                              {referral.howToAccessService}
                            </dd>
                            <br />
                            <dt>NotesForPatient</dt>
                            <dd>
                              {referral.notesForPatient}
                            </dd>
                            <br />
                            <dt>InternalNotes</dt>
                            <dd>
                              {referral.internalNotes}
                            </dd>
                            <br />
                            <dt>QualityCheck</dt>
                            <dd>
                              {referral.qualityCheck}
                            </dd>
                            <br />
                            <dt>CostEffectiveCheck</dt>
                            <dd>
                              {referral.costEffectiveCheck}
                            </dd>
                            <br />
                            <dt>PatientFeedback</dt>
                            <dd>
                              {referral.patientFeedback}
                            </dd>
                            <br />
                            <dt>Contacts</dt>
                            <dd>
                              {contacts && contacts.data.list && 
                                contacts.data.list.map(el => (
                                  <li key={el.contact.id}>
                                    <span>
                                      {el.contact.contactName}
                                    </span>
                                    <br />
                                  </li>
                                ))}
                            </dd>
                            <br />
                            <dt>Locations</dt>
                            <dd>
                              {referral.location &&
                                referral.location.map(el => (
                                  <li key={el.clinicLocation.clinicLocationID}>
                                    <span>
                                      {el.clinicLocation.siteName}
                                    </span>
                                    <br />
                                  </li>
                                ))}
                            </dd>
                          </dl>
                        </div>
                      </div>

                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.referraldirectory,
    contacts: state.contactmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  dispatch => ({
    getReferral: (referralId, params) => dispatch(requestReferralDetails(referralId, params)),
    getReferralContacts: (referralId, params) => dispatch(requestReferralContacts(referralId, params)),
  }),
)(ReferralDetail);



// WEBPACK FOOTER //
// ./src/routes/resource-library/containers/ReferralDetail.js